import React, { useEffect, useState } from 'react';
const comparisonRows = [{
  without: 'Rayones circulares en cada lavado',
  with: 'Protocolo de 3 baldes → cero swirl marks'
}, {
  without: 'Cobrás $30.000 por un trabajo de 6 horas',
  with: 'Sistema de precios → $150k a $400k por servicio'
}, {
  without: 'Clientes que regatean hasta el último peso',
  with: 'Clientes de alto ticket que pagan sin dudar'
}, {
  without: 'High spots y errores al aplicar cerámicos',
  with: 'Protocolo anti-High Spots → sellado perfecto'
}, {
  without: 'Agenda vacía o llena de trabajos baratos',
  with: 'Sistema de captación → agenda llena en 30 días'
}, {
  without: 'Gastás en insumos sin saber qué usar',
  with: 'Tabla de diluciones → costos reducidos a la mitad'
}, {
  without: 'Sin contrato ni protección legal',
  with: 'Contrato pro → te protegés antes de tocar el auto'
}, {
  without: 'Fotos malas que no generan confianza',
  with: 'Sistema de fotos → cada imagen trae un cliente nuevo'
}, {
  without: 'Garage sin identidad ni posicionamiento',
  with: 'Taller de estética automotriz de élite reconocido'
}];
export function DarkCTA() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 26,
    seconds: 56
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) return {
          hours: 0,
          minutes: 0,
          seconds: 0
        };
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section className="w-full px-4 py-16 sm:py-20 text-base leading-6" style={{
    backgroundColor: '#080808',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-87">
      <div className="mx-auto max-w-4xl text-center" data-id="element-88">
        {/* Brand */}
        <div className="mb-8 text-2xl sm:text-3xl font-black tracking-[3px] text-yellow-400" data-id="element-89">
          🚗 MEGAPACK DETAILER ARGENTINO™
        </div>

        {/* Headlines */}
        <h2 className="text-xl sm:text-3xl font-bold text-white m-0 mb-3" data-id="element-90">
          Mañana podés seguir cobrando $30.000 por 6 horas de trabajo.
        </h2>
        <p className="text-xl sm:text-3xl font-black text-yellow-400 m-0 mb-10" data-id="element-91">
          O podés instalar el sistema que te convierte en Detailer Pro desde
          hoy.
        </p>

        {/* Comparison Table */}
        <div className="mx-auto max-w-2xl mb-12 overflow-hidden rounded-2xl border border-yellow-400/20 text-left" style={{
        backgroundColor: 'rgba(255,255,255,0.02)'
      }} data-id="element-92">
          {/* Table Title */}
          <div className="text-center font-bold text-white border-b border-yellow-400/20 px-4 py-4" style={{
          backgroundColor: 'rgba(255,255,255,0.03)'
        }} data-id="element-93">
            ¿Cuánto cuesta NO tenerlo?
          </div>

          {/* Table Header */}
          <div className="grid grid-cols-2 border-b border-yellow-400/20" style={{
          backgroundColor: 'rgba(255,255,255,0.03)'
        }} data-id="element-94">
            <div className="text-center font-bold text-gray-500 px-4 py-3 text-sm" data-id="element-95">
              SIN MEGAPACK
            </div>
            <div className="text-center font-bold text-yellow-400 border-l border-yellow-400/20 px-4 py-3 text-sm" data-id="element-96">
              CON MEGAPACK
            </div>
          </div>

          {/* Rows */}
          {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i < comparisonRows.length - 1 ? 'border-b border-white/5' : ''}`} data-id="element-97">
              <div className="px-4 py-3 text-xs sm:text-sm text-gray-500" data-id="element-98">
                {row.without}
              </div>
              <div className="px-4 py-3 text-xs sm:text-sm font-bold text-gray-200 border-l border-white/5" style={{
            backgroundColor: 'rgba(234, 179, 8, 0.05)'
          }} data-id="element-99">
                {row.with}
              </div>
            </div>)}
        </div>

        {/* Countdown */}
        <div className="mb-4" data-id="element-100">
          <p className="font-bold text-white m-0 mb-4" data-id="element-101">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <div className="flex items-center justify-center gap-0" data-id="element-102">
            <div className="flex flex-col items-center" data-id="element-103">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-104">
                {pad(timeLeft.hours)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-105">
                hs
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-106">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-107">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-108">
                {pad(timeLeft.minutes)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-109">
                min
              </span>
            </div>
            <span className="mb-4 text-5xl sm:text-7xl font-black animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-110">
              :
            </span>
            <div className="flex flex-col items-center" data-id="element-111">
              <span className="text-5xl sm:text-7xl font-black tabular-nums animate-countdown-blink will-change-[opacity] text-[rgb(255,68,68)]" data-id="element-112">
                {pad(timeLeft.seconds)}
              </span>
              <span className="text-xs sm:text-sm uppercase tracking-wide text-gray-500" data-id="element-113">
                seg
              </span>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-400 m-0 mb-12" data-id="element-114">
          Después sube{' '}
          <span className="font-bold text-red-500" data-id="element-115">$8.000 ARS</span> y no
          vuelve.
        </p>

        {/* Two Pricing Cards */}
        <div className="mx-auto max-w-2xl mb-10 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-116">
          {/* Standard */}
          <div className="flex flex-col rounded-xl p-6 border border-white/10 shadow-sm" style={{
          backgroundColor: 'rgba(255,255,255,0.03)'
        }} data-id="element-117">
            <div className="mb-2 text-2xl" data-id="element-118">🚗</div>
            <h3 className="text-base font-black text-white m-0 mb-1" data-id="element-119">
              MEGAPACK DETAILER ARGENTINO
            </h3>
            <p className="text-xs text-gray-400 m-0 mb-4" data-id="element-120">6 Tomos + 4 Bonos</p>
            <div className="mt-auto" data-id="element-121">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-122">
                Antes: $49.990 ARS
              </p>
              <p className="text-2xl font-black text-yellow-400 m-0 mb-4" data-id="element-123">
                Hoy: $19.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48195932749994:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'MegaPack Detailer Argentino',
                  content_category: 'Detailer Argentino',
                  value: 19990,
                  currency: 'ARS'
                });
              }
            }} className="block bg-yellow-400 text-gray-900 text-center text-sm font-black rounded-lg py-4 no-underline transition-colors animate-pulse-green will-change-transform" data-id="element-124">
                → QUIERO MI MEGAPACK
              </a>
            </div>
          </div>

          {/* Pro */}
          <div className="flex flex-col rounded-xl p-6 border-2 border-yellow-400 shadow-sm" style={{
          backgroundColor: 'rgba(234, 179, 8, 0.05)',
          boxShadow: 'rgba(234, 179, 8, 0.15) 0px 0px 30px 0px'
        }} data-id="element-125">
            <div className="mb-2 text-2xl" data-id="element-126">🏆</div>
            <h3 className="text-base font-black text-yellow-400 m-0 mb-1" data-id="element-127">
              MEGAPACK + EL MÉTODO CERÁMICO™ ⭐
            </h3>
            <p className="text-xs text-gray-400 m-0 mb-1" data-id="element-128">La más elegida</p>
            <p className="text-xs text-gray-400 m-0 mb-4" data-id="element-129">
              6 Tomos + 4 Bonos + El Método Cerámico™
              <br data-id="element-130" />
              (sellado cerámico avanzado, clientes de lujo y +$400.000 por
              servicio)
            </p>
            <div className="mt-auto" data-id="element-131">
              <p className="text-sm text-gray-500 line-through m-0 mb-1" data-id="element-132">
                Antes: $69.990 ARS
              </p>
              <p className="text-3xl font-black text-yellow-400 m-0 mb-4" data-id="element-133">
                Hoy: $27.990 ARS
              </p>
              <a href="https://checkout.construyeprogreso.com/cart/48195645341866:1" onClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'MegaPack + El Método Cerámico™',
                  content_category: 'Detailer Argentino',
                  value: 27990,
                  currency: 'ARS'
                });
              }
            }} className="block bg-yellow-400 text-gray-900 text-center text-sm font-black rounded-lg py-4 no-underline transition-colors animate-pulse-green will-change-transform" data-id="element-134">
                → QUIERO EL MEGAPACK + EL MÉTODO CERÁMICO™
              </a>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-500" data-id="element-135">
          <span data-id="element-136">🔒 Pago 100% seguro</span>
          <span data-id="element-137">⚡ Acceso en 5 minutos</span>
          <span data-id="element-138">🛡️ Garantía 30 días sin preguntas</span>
          <span data-id="element-139">💳 Mercado Pago | Tarjeta | Transferencia</span>
        </div>
      </div>
    </section>;
}